import { useEffect, useState } from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import SliderNavigation from "../Slider/SliderNavigation";
import { StaticImage } from "gatsby-plugin-image";
import CircleStatsSection from "../Section/CircleStatsSection";
import stores from "../../utils/stores.json";
import { easeInOutExpo } from "../../utils/animations";

const activeStores = stores.filter((store) => !store.flashAlert); // filter out flash alerts
const currentYear = new Date().getFullYear();

interface SectionCarousel {
  autoPlay?: boolean;
  timing?: number;
  speed?: number;
}

const items = [
  <CircleStatsSection
    image={
      <StaticImage
        src="../../images/home/Circle1.png"
        alt="Canada"
        placeholder="none"
      />
    }
    stats={[
      {
        number: <>{currentYear - 1992}</>,
        stat: "Years in Service",
      },
      {
        number: "19 Million+",
        stat: "Customer Loans since 2000",
      },
    ]}
    title="Loyalty"
    text="The Cash Money Line of Credit, Payday Loan, and Auto Equity Loan products can help with your long-term and short-term lending needs. Whether you have a surprise expense, a special purchase, or are short on funds, we’re your choice for personal loans."
  />,
  <CircleStatsSection
    reverse
    image={
      <StaticImage
        src="../../images/home/Circle2.png"
        alt="Location"
        placeholder="none"
      />
    }
    stats={[
      {
        number: <>{Math.floor((activeStores.length - 1) / 10) * 10}+</>,
        stat: "Branches",
      },
    ]}
    title="Locations"
    text="For an in-person loan journey, conveniently visit us at one of our branches. Our Cash Money representatives are happy to help you one-on-one throughout the loan process."
  />,
  <CircleStatsSection
    image={
      <StaticImage
        src="../../images/home/Circle3.png"
        alt="Customer Service"
        placeholder="none"
      />
    }
    stats={[
      {
        number: "3 Million+",
        stat: "Canadian Customers since 2005",
      },
    ]}
    title="Customer Service"
    text="Every Customer experience is important. Our representatives are professional, friendly, and well-educated so they can find the best solution for you."
  />,
];

const SectionCarousel = (props: SectionCarousel) => {
  let { autoPlay = true, timing = 6700 } = props;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      defaultAnimation: {
        easing: (t) => easeInOutExpo(t),
        duration: 500,
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    []
  );

  useEffect(() => {
    window.innerWidth < 800 ? setIsMobile(true) : setIsMobile(false);
  }, []);

  return (
    <div
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        sx={{
          display: ["block", null, null, "none"],
          width: "100%",
        }}
      >
        <div ref={sliderRef} className="keen-slider">
          {items.map((child: any, i: number) => (
            <div
              className={`keen-slider__slide`}
              sx={{
                zIndex: 2,
                position: ["relative"],
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                pb: [3, null, null, 0],
                width: "100%",
              }}
              key={i}
            >
              {child}
            </div>
          ))}
        </div>
      </div>
      <div
        sx={{
          display: ["none", null, null, "block"],
        }}
      >
        {items.map((child: any, i: number) => (
          <div
            data-sal={isMobile ? "" : "slide-up"}
            data-sal-delay="0"
            data-sal-duration="1000"
            data-sal-easing="easeOutQuart"
            sx={{
              zIndex: 2,
              position: ["relative"],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pb: [3, null, null, 0],
              width: "100%",
            }}
            key={i}
          >
            {child}
          </div>
        ))}
      </div>

      <div
        sx={{
          display: ["block", null, null, "none"],
        }}
      >
        {loaded && instanceRef.current && (
          <SliderNavigation
            instanceRef={instanceRef}
            currentSlide={currentSlide}
          />
        )}
      </div>
    </div>
  );
};

export default SectionCarousel;
